export const whyAdvertise = {
    header: {
        logo: "https://fastly-production.24c.in/cars24/seo/static/1_20230830_1693395013.png"
    },
    pageTitle: {
        heading: "Benefits of advertising on our platform vs others",
        tableColumns: [
            {
                key: "cars24",
                label: "CARS24",
                color: "#000"
            },
            {
                key: "otherPlatforms",
                label: "Other plateforms",
                color: "#717272"
            }
        ],

        tableData: [
            {
                cars24: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                    label: "Smart AI pricing engine"
                },
                otherPlatforms: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Warning+Circle.png",
                    label: "Manual pricing hassles"
                }
            },
            {
                cars24: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                    label: "Zero spam platform"
                },
                otherPlatforms: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Warning+Circle.png",
                    label: "Full of spam"
                }
            },
            {
                cars24: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                    label: "Multi-Step verified buyers"
                },
                otherPlatforms: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Warning+Circle.png",
                    label: "Unverified random users"
                }
            },
            {
                cars24: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                    label: "Free car inspection"
                },
                otherPlatforms: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Warning+Circle.png",
                    label: "No inspection support"
                }
            },
            {
                cars24: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                    label: "Guaranteed post-sale protection"
                },
                otherPlatforms: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Warning+Circle.png",
                    label: "Fraud-prone practices"
                }
            },
            {
                cars24: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                    label: "End-to-End assistance"
                },
                otherPlatforms: {
                    icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Warning+Circle.png",
                    label: "Zero seller assistance"
                }
            }
        ]
    },
    cars24Offer: {
        heading: "What can CARS24 offer me?",
        offers: [
            {
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                label: "Exclusive data to help you get the best price"
            },
            {
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                label: "Reach lakhs of potential buyers across India"
            },
            {
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                label: "Post sales assistance"
            },
            {
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/Check+circle.png",
                label: "Fraud-free sales, 0 spam"
            }
        ]
    },
    whyToSell: {
        heading: "Why sell at marketplace?",
        benifits: [
            "https://c2c-marketplace.s3.amazonaws.com//static/doc/analytics.png",
            "https://c2c-marketplace.s3.amazonaws.com//static/doc/marketing.png",
            "https://c2c-marketplace.s3.amazonaws.com//static/doc/middleman.png",
            "https://c2c-marketplace.s3.amazonaws.com//static/doc/privacy.png",
            "https://c2c-marketplace.s3.amazonaws.com//static/doc/verification.png"
        ]
    },
    smartSolution: {
        heading: "Smart solutions for sellers",
        solutions: [
            {
                label: "Get market data to help pricing",
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/pricing.png"
            },
            {
                label: "View analytics on-the-go",
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/click-views.png"
            },
            {
                label: "Compare and pick the best offer",
                icon: "https://c2c-marketplace.s3.amazonaws.com/static/doc/chat-demo.png"
            },
            {
                label: "Connect with buyers on your terms",
                icon: "https://c2c-marketplace.s3.ap-south-1.amazonaws.com/static/doc/chat-option.png"
            }
        ]
    },
    stepsToSell: {
        heading: "Sell your car in 3-easy steps",
        steps: [
            "List your pre-inspected car",
            "Interested buyers will contact you",
            "Secure your sale with CARS24"
        ]
    }
};
